import {
  GET_ALL_USERS,
  GET_FILTERED_USERS,
  EDIT_USER,
  EDIT_PERMISSIONS,
  SUSPEND_USER,
  RESTORED_USER,
  ADD_USER_TO_TEAM,
  MAKE_LEADER,
  REMOVE_USER_FROM_TEAM,
  CREATE_USER,
  EDIT_ADMIN_CREDITS,
  EDIT_USER_CREDITS,
  DELETE_USER,
  EDIT_BULK_USERS_CREDITS,
  LOGOUT,
} from 'constants/actionTypes';
import initialState from './initState';

export default function users(state = initialState, action = {}) {
  switch (action.type) {
    case GET_ALL_USERS:
      return {
        ...state,
        allUsers: action.payload,
        filteredUsers: action.payload,
      };
    case GET_FILTERED_USERS:
      return {
        ...state,
        filteredUsers: action.payload,
      };
    case EDIT_USER: {
      const index = state?.allUsers.findIndex((i) => i.id === action.payload.id);
      const newUsers = [...state.allUsers];
      newUsers[index] = { ...newUsers[index], ...action.payload };

      const indexFilteredUsers = state?.filteredUsers.findIndex((i) => i.id === action.payload.id);
      const newFilteredUsers = [...state.filteredUsers];
      newFilteredUsers[indexFilteredUsers] = { ...newFilteredUsers[indexFilteredUsers], ...action.payload };

      return {
        ...state,
        allUsers: newUsers,
        filteredUsers: newFilteredUsers,
      };
    }

    case EDIT_ADMIN_CREDITS: {
      const index = state?.allUsers.findIndex((i) => i.id === action.payload.id);
      const newUsers = [...state.allUsers];
      newUsers[index] = { ...newUsers[index], ...action.payload };

      const indexFilteredUsers = state?.filteredUsers.findIndex((i) => i.id === action.payload.id);
      const newFilteredUsers = [...state.filteredUsers];
      newFilteredUsers[indexFilteredUsers] = { ...newFilteredUsers[indexFilteredUsers], ...action.payload };

      return {
        ...state,
        allUsers: newUsers,
        filteredUsers: newFilteredUsers,
      };
    }

    case EDIT_USER_CREDITS: {
      if (state?.allUsers) {
        const index = state?.allUsers?.findIndex((i) => i.id === action.payload.id);
        const newUsers = [...state.allUsers];
        newUsers[index] = { ...newUsers[index], ...action.payload };

        const indexFilteredUsers = state?.filteredUsers?.findIndex((i) => i.id === action.payload.id);
        const newFilteredUsers = [...state.filteredUsers];
        newFilteredUsers[indexFilteredUsers] = { ...newFilteredUsers[indexFilteredUsers], ...action.payload };

        return {
          ...state,
          allUsers: newUsers,
          filteredUsers: newFilteredUsers,
        };
      }
      return {
        ...state,
      };
    }

    case EDIT_BULK_USERS_CREDITS: {
      if (state?.allUsers) {
        const updatesMap = new Map(
          action.payload.map(({ user_id, allocated_credits }) => [user_id, allocated_credits]),
        );

        const newUsers = state.allUsers.map((user) => {
          if (updatesMap.has(user.id)) {
            return {
              ...user,
              allocated_credits: updatesMap.get(user.id),
            };
          }
          return user;
        });

        const newFilteredUsers = state.filteredUsers.map((user) => {
          if (updatesMap.has(user.id)) {
            return {
              ...user,
              allocated_credits: updatesMap.get(user.id),
            };
          }
          return user;
        });

        return {
          ...state,
          allUsers: newUsers,
          filteredUsers: newFilteredUsers,
        };
      }
      return {
        ...state,
      };
    }

    case EDIT_PERMISSIONS: {
      const index = state?.allUsers.findIndex((i) => i.id === action.payload.id);
      const newUsers = [...state.allUsers];
      newUsers[index] = { ...newUsers[index], ...action.payload };

      const indexFilteredUsers = state?.filteredUsers.findIndex((i) => i.id === action.payload.id);
      const newFilteredUsers = [...state.filteredUsers];
      newFilteredUsers[indexFilteredUsers] = { ...newFilteredUsers[indexFilteredUsers], ...action.payload };

      return {
        ...state,
        allUsers: newUsers,
        filteredUsers: newFilteredUsers,
      };
    }

    case SUSPEND_USER:
    case RESTORED_USER: {
      const index = state?.allUsers.findIndex((i) => i.id === action.payload.id);
      const newUsers = [...state.allUsers];
      newUsers[index] = action.payload;

      const indexFilteredUsers = state?.filteredUsers.findIndex((i) => i.id === action.payload.id);
      const newFilteredUsers = [...state.filteredUsers];
      newFilteredUsers[indexFilteredUsers] = action.payload;

      if (index >= 0) {
        return {
          ...state,
          allUsers: newUsers,
          filteredUsers: newFilteredUsers,
        };
      }
      return state;
    }

    case REMOVE_USER_FROM_TEAM: {
      const index = state?.allUsers.findIndex((i) => i.id === action.payload.id);
      const newUsers = [...state.allUsers];
      newUsers[index] = { ...action.payload, team: null };

      const indexFilteredUsers = state?.filteredUsers.findIndex((i) => i.id === action.payload.id);
      const newFilteredUsers = [...state.filteredUsers];
      newFilteredUsers[indexFilteredUsers] = { ...action.payload, team: null };

      if (index >= 0) {
        return {
          ...state,
          allUsers: newUsers,
          filteredUsers: newFilteredUsers,
        };
      }
      return state;
    }

    case ADD_USER_TO_TEAM: {
      const index = state?.allUsers.findIndex((i) => i.id === action.payload.id);
      const newUsers = [...state.allUsers];
      newUsers[index] = action.payload;

      const indexFilteredUsers = state?.filteredUsers.findIndex((i) => i.id === action.payload.id);
      const newFilteredUsers = [...state.filteredUsers];
      newFilteredUsers[indexFilteredUsers] = action.payload;

      if (index >= 0) {
        return {
          ...state,
          allUsers: newUsers,
          filteredUsers: newFilteredUsers,
        };
      }
      return state;
    }
    case MAKE_LEADER: {
      const index = state?.allUsers.findIndex((i) => i.id === action.payload.id);
      const newUsers = [...state.allUsers];
      newUsers[index] = { ...newUsers[index], ...action.payload };

      const indexFilteredUsers = state?.filteredUsers.findIndex((i) => i.id === action.payload.id);
      const newFilteredUsers = [...state.filteredUsers];
      newFilteredUsers[indexFilteredUsers] = { ...newFilteredUsers[indexFilteredUsers], ...action.payload };

      return {
        ...state,
        allUsers: newUsers,
        filteredUsers: newFilteredUsers,
      };
    }

    case CREATE_USER: {
      return {
        ...state,
        allUsers: [...state.allUsers, action.payload],
        filteredUsers: [...state.filteredUsers, action.payload],
      };
    }
    case DELETE_USER: {
      const index = state?.allUsers.findIndex((i) => i.id === action.payload.id);
      const newUsers = [...state.allUsers];
      newUsers.splice(index, 1);

      const indexFilteredUsers = state?.filteredUsers.findIndex((i) => i.id === action.payload.id);
      const newFilteredUsers = [...state.filteredUsers];

      newFilteredUsers.splice(indexFilteredUsers, 1);
      return {
        ...state,
        allUsers: newUsers,
        filteredUsers: newFilteredUsers,
      };
    }
    case LOGOUT:
      return initialState;
    default:
      return state;
  }
}
